import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Dialog, IconButton } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import styles from './styles.scss';
import RTButton from './iconButtonTheme.scss';
import { isPlainObject } from 'lodash';

const theme = { RTButton };

class UploadTableRow extends Component {
  constructor(props) {
    super(props);
    this.state = { summaryDialogIsActive: false };
    this.openSummaryDialog = this.toggleSummaryDialog.bind(this, true);
    this.closeSummaryDialog = this.toggleSummaryDialog.bind(this, false);
    this.renderSummary = this.renderSummary.bind(this);
    this.renderSummaryButton = this.renderSummaryButton.bind(this);
    this.actions = [{ label: 'OK', onClick: this.closeSummaryDialog }];
  }

  toggleSummaryDialog = active => this.setState({ summaryDialogIsActive: active });

  parseSummaryError = (error) => {
    if (!isPlainObject(error)) return error;
    return Object.keys(error).map(key => error[key]).join(' ');
  }

  renderSummary = () => {
    const { rowData: { statusText, summary } } = this.props;
    if (statusText === 'error') {
      const summaryObject = summary || {};
      return (<div>{this.parseSummaryError(summaryObject.error)}</div>);
    }
    const summaryArray = summary || [];
    return summaryArray.map(action => (<div key={action.action_type}>
      {action.action_type}: {action.value}
    </div>));
  }

  renderBelongsTo = () => {
    const { crews, rowData: { crewId } } = this.props;
    return crewId ? `Crew: ${crews.find(c => c.id === crewId).name}` : 'Installer';
  }

  renderSummaryButton = status => (status === 'pending' ? null : (<ThemeProvider theme={theme}>
    <IconButton
      onClick={this.openSummaryDialog}
      icon="announcement"
      className={styles.summaryLink}
    />
  </ThemeProvider>));

  render = () => {
    const { rowData, canDownload, crews, isPayRate } = this.props;
    const summary = this.renderSummary();
    const summaryButton = this.renderSummaryButton(rowData.statusText);
    const mobileUploadDate = rowData.uploadedOnMobile || rowData.uploadedOn;
    return (<tr
      key={rowData.id}
      className={!isPayRate && rowData.active ? styles.latestSuccess : null}
    >
      {canDownload && <td data-label="Download" className={styles.downloadLink}>
        {rowData.uploadName}
      </td>}
      {crews && <td data-label="Belongs To">{this.renderBelongsTo()}</td>}
      <td data-label="Uploaded By">{rowData.uploadedBy}</td>
      <td data-label="Uploaded On">
        <span className={styles.desktopDate}>{rowData.uploadedOn}</span>
        <span className={styles.mobileDate}>{mobileUploadDate}</span>
      </td>
      <td data-label="Status">
        <span className={styles.statusText}>{rowData.statusText}</span>
        {summaryButton}
        <Dialog
          actions={this.actions}
          active={this.state.summaryDialogIsActive}
          title="Upload Summary"
          onEscKeyDown={this.closeSummaryDialog}
          onOverlayClick={this.closeSummaryDialog}
        >{summary}</Dialog>
      </td>
    </tr>);
  }
}

UploadTableRow.defaultProps = { crews: null, isPayRate: false };

UploadTableRow.propTypes = {
  canDownload: PropTypes.bool.isRequired,
  rowData: PropTypes.object,
  crews: PropTypes.array,
  isPayRate: PropTypes.bool,
};

export default UploadTableRow;



// WEBPACK FOOTER //
// ./client/app/shared/components/UploadsTable/uploadTableRow.jsx